function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M241.531 79.2781C241.042 79.2781 240.915 79.0571 240.915 78.5361V70.3851H233.475C233.753 69.3421 233.948 68.2961 234.056 67.2561H231.865C231.795 68.2641 231.579 69.3131 231.238 70.3851H223.963V72.5991H230.355C228.845 75.7281 226.219 78.8821 222.51 81.4831H225.265C225.77 81.4831 226.167 81.3901 226.543 81.0671C229.544 78.4951 231.546 75.5971 232.74 72.5991H238.805V79.2531C238.805 80.5771 239.47 81.4891 240.704 81.4891H245.175L245.807 79.2781H241.531Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.275 57.7019H33V81.2499H53.275V57.7019ZM51.297 78.9079H34.983V70.6509H51.297V78.9079ZM51.297 68.3069H34.983V60.0469H51.297V68.3069Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0718 80.5839C60.0718 80.5839 60.7228 79.3299 61.1418 78.3479C62.5468 80.0399 64.2538 81.1979 66.3718 81.2529H81.8408L82.4458 79.0489H67.1438C65.0498 78.9979 63.3588 77.8649 61.9728 76.2179C63.0048 73.2619 63.6148 70.1879 63.9558 66.8799H61.1438C62.3968 64.9539 63.4668 62.1679 63.7638 59.1509H57.5878V61.3869H61.2758C60.8708 63.2259 60.0518 65.2129 59.0768 66.8799H57.3938V69.1099H61.6268C61.4428 70.6579 61.0868 72.2639 60.6138 73.8409C60.4138 73.4469 60.2168 73.0479 60.0198 72.6639L59.5308 71.5029H57.4318C58.0778 73.1439 58.8338 74.8519 59.7498 76.3689C59.4038 77.2679 59.0258 78.1409 58.6288 78.9629C58.2318 79.7819 57.7618 80.6109 57.2778 81.2529H59.0608C59.4288 81.2519 59.8828 80.9519 60.0718 80.5839Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80.3709 68.121V64.186H82.0029V62.238H80.3709V58.553H74.0979V57.2H71.7849V58.553H65.5119V60.511H71.7849V62.238H63.8799V64.186H71.7849V66.173H65.5119V68.121H71.7849V69.868H65.5119V71.829H71.7849V73.736H63.8799V75.691H71.7849V78.173H74.0979V75.69H82.0029V73.735H74.0979V71.828H80.3709V69.867H74.0979V68.12H80.3709V68.121ZM78.3879 66.173H74.0979V64.186H78.3879V66.173ZM74.0979 60.511H78.3879V62.238H74.0979V60.511Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0019 57.7051H86.4629V59.9701H96.0019V57.7051Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M96.5722 61.96H85.9092V64.225H96.5722V61.96Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0049 65.856H86.4629V67.897H96.0049V65.856Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0049 69.5901H86.4629V71.6181H96.0049V69.5901Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0049 73.4121H86.4629V81.2501H96.0049V73.4121ZM94.0219 79.2251H88.4429V75.4471H94.0219V79.2251Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M109.623 67.4521L110.685 67.5931L111.277 65.4311L109.983 65.3291C109.137 65.2751 108.692 64.8781 108.692 63.8701V57.7051H99.691V63.8691C99.691 64.9701 98.999 65.2481 98.224 65.3411L97.106 65.4591L97.665 67.4941L98.108 67.4781C100.826 67.2481 101.606 66.1701 101.606 63.8691V59.9691H106.777V63.8691C106.775 66.5121 107.912 67.2031 109.623 67.4521Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M101.034 80.8269C101.034 80.8269 102.606 79.6269 103.992 78.3479C105.04 79.3519 106.807 80.8049 106.807 80.8049C107.107 81.0509 107.65 81.2529 108.015 81.2529H111.051C110.146 80.6839 109.144 79.9379 108.231 79.2059C107.315 78.4699 106.397 77.6859 105.511 76.8739C107.737 74.5899 109.906 71.7879 110.674 69.0649H97.6492V70.7889C99.0862 72.9099 100.737 75.0049 102.644 77.0009C101.871 77.6819 101.026 78.3699 100.099 79.0739C99.1701 79.7779 98.0781 80.5709 96.9521 81.2529H99.8132C100.178 81.2529 100.726 81.0609 101.034 80.8269ZM100.415 71.1729H107.555C106.715 72.6989 105.602 74.1379 104.159 75.5839C102.72 74.1569 101.415 72.6599 100.415 71.1729Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M125.022 57.7019H114.932V59.9669H125.022V57.7019Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M125.589 61.96H114.375V64.225H125.589V61.96Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M125.022 65.856H114.932V67.897H125.022V65.856Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M125.022 69.5901H114.932V71.6181H125.022V69.5901Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M114.932 81.253H125.022V73.415H114.932V81.253ZM116.912 75.447H123.042V79.225H116.912V75.447Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M131.193 81.757H133.503V67.896H139.049V65.858H133.503V57.198H131.193V65.858H125.646V67.896H131.193V81.757Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M143.263 79.5899C143.633 77.7029 144.025 74.5199 144.195 72.2319H142.307C142.099 74.1769 141.686 77.9069 141.14 80.1489H142.669C142.936 80.1499 143.201 79.9129 143.263 79.5899Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M148.082 72.2329C148.19 73.7649 148.344 75.3169 148.547 76.5839C148.582 76.8109 148.749 77.0319 148.987 77.0319H150.521C150.205 75.4169 149.937 73.7149 149.813 72.2339H148.082V72.2329Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M151.668 73.135C151.371 75.381 150.776 78.775 150.006 80.678H151.635C151.916 80.678 152.102 80.509 152.189 80.214C152.775 78.25 153.28 75.435 153.556 73.135H151.668Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M160.701 72.999C161.398 75.123 162.262 77.606 163.197 79.88C163.31 80.155 163.581 80.331 163.843 80.331H165.556C164.516 77.781 163.416 74.848 162.83 72.999H160.701Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M159.087 77.1749H160.681C160.003 75.4959 159.271 73.6949 158.782 72.0759H156.872C157.285 73.5729 157.896 75.3099 158.452 76.7149C158.573 77.0219 158.781 77.1749 159.087 77.1749Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M260.087 58.124H248.838V60.315H260.087V58.124Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M190.212 69.9351H170.707V80.9361H190.212V69.9351ZM187.929 78.7671H172.99V72.0401H187.929V78.7671Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M225.416 61.471H230.022C229.414 64.379 226.753 66.161 223.711 66.631L224.384 68.848C229.33 67.549 231.519 64.872 232.172 61.471H235.633V65.934C235.633 67.121 236.09 67.773 237.194 67.773H243.272L243.837 65.7H238.01C237.575 65.7 237.553 65.61 237.553 65.147V61.471H242.948V64.731H245.136V59.312H235.202V57.229H233.062V59.312H223.226V64.53H225.414V61.471H225.416Z",
  fill: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M205.878 81.48H207.604C208.061 81.48 208.36 81.253 208.566 80.882C209.722 78.806 210.695 74.484 210.695 70.073V68.976H214.926V81.999H216.977V68.975H220.095V66.784H216.977V60.472H219.4V58.281H206.484V60.472H208.645V66.784H205.957V68.975H208.645V69.909C208.645 74.698 207.605 78.748 205.878 81.48ZM210.695 60.472H214.926V66.784H210.695V60.472Z",
  fill: "black"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M259.768 81.4819C260.135 81.4819 260.424 81.3089 260.646 80.9249C262.405 77.9049 263.248 73.8779 263.248 69.4149L263.28 67.7229H267.91V81.9999H270.096V67.7229H273V65.4769H263.326L263.41 61.2899C265.906 61.2069 270.058 60.6209 272.438 59.7319L271.817 57.6399C269.205 58.6029 263.969 59.2709 261.197 59.2459V69.2519C261.197 74.0409 260.165 78.0679 257.799 81.4819H259.768Z",
  fill: "black"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M250.856 80.8881C251.548 79.0291 252.042 76.3651 252.131 72.8301H259.285V63.0061H250.054V71.5091C250.054 74.8581 249.489 79.0011 248.241 81.4801H250.016C250.378 81.4801 250.716 81.2661 250.856 80.8881ZM257.191 70.6071H252.15V65.1721H257.191V70.6071Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M145.289 70.007V81.936H147.245V69.934C147.799 69.876 148.372 69.774 148.914 69.608C149.027 69.931 149.138 70.235 149.246 70.501C149.368 70.802 149.54 70.91 149.851 70.91H151.423C150.802 69.355 150.178 67.465 149.788 66.048H147.862C148.005 66.64 148.186 67.302 148.384 67.955C147.641 68.089 146.806 68.163 146.001 68.163H144.753C146.312 65.729 148.108 62.613 149.621 59.625H147.536C146.869 60.93 145.947 62.542 144.921 64.263C144.559 63.806 144.192 63.351 143.849 62.939C144.843 61.375 145.907 59.606 146.834 57.686H144.743C143.808 59.449 142.59 61.477 141.482 63.134C142.109 63.857 143.111 64.986 143.913 65.933C143.084 67.289 142.211 68.675 141.365 70.008H145.289V70.007Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M155.67 61.688C154.727 63.918 153.03 67.654 151.807 70.143H157.575C158.869 70.143 160.277 70.05 161.498 69.654C161.563 69.779 161.63 69.907 161.692 70.025C161.908 70.418 162.119 70.572 162.503 70.572H164.375C163.162 68.442 161.838 65.834 161.02 63.809H158.832C159.353 65.143 160.015 66.65 160.677 68.022C159.777 68.172 158.672 68.24 157.851 68.24H154.833C155.714 66.532 156.667 64.449 157.753 61.688H155.67Z",
  fill: "black"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M156.472 57.7019H154.305C153.435 59.5989 152.298 61.2689 150.507 62.5709C150.769 63.5239 150.896 63.9819 151.069 64.6149C153.649 62.9669 155.478 60.2709 156.472 57.7019Z",
  fill: "black"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M164.144 64.5969L164.76 62.3639C163.02 61.1549 161.68 59.6029 160.808 57.7029H158.596C159.578 60.4059 161.499 62.9359 164.144 64.5969Z",
  fill: "black"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M154.322 73.0611V79.3661C154.322 80.5531 154.778 81.1511 155.881 81.1511H161.773L162.313 79.1741H156.759C156.321 79.1741 156.3 79.0841 156.3 78.6171V73.0601H154.322V73.0611Z",
  fill: "black"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M172.276 64.767V66.501H188.347V64.671C189.763 65.429 191.227 66.146 192.683 66.801L193.28 64.626C189.095 62.604 184.457 59.933 181.593 57H179.313C176.582 59.911 171.889 62.691 167.632 64.626C167.862 65.461 167.989 65.922 168.221 66.779C169.556 66.162 170.925 65.487 172.276 64.767ZM180.432 59.23C182.396 61.095 185.016 62.842 187.848 64.4H172.957C175.785 62.848 178.468 61.095 180.432 59.23Z",
  fill: "black"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M195.497 73.406C196.102 72.856 196.867 71.663 197.391 70.732V80.988H205.053V65.898H199.35H199.336C199.72 64.289 200.079 62.203 200.247 60.527H205.474V58.281H195.67V60.527H198.318C197.861 64.964 196.473 68.774 194.811 70.914C195.099 71.96 195.31 72.725 195.497 73.406ZM203.096 78.761H199.346V68.057H203.096V78.761Z",
  fill: "black"
});

var _ref38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoNsri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNsri);
export default __webpack_public_path__ + "static/media/logo_nsri.e629b08b.svg";
export { ForwardRef as ReactComponent };